<script lang="ts">import { Container } from "@infinitro/container";
import VipCashback from "./parts/modern/vip-cashback.svelte";
import VipClaimSteps from "./parts/modern/vip-claim-steps.svelte";
import VipCta from "./parts/modern/vip-cta.svelte";
import VipHero from "./parts/modern/vip-hero.svelte";
import VipLevelUp from "./parts/modern/vip-level-up.svelte";
import VipRakeback from "./parts/modern/vip-rakeback.svelte";
import VipRakeboost from "./parts/modern/vip-rakeboost.svelte";
import VipReason from "./parts/modern/vip-reason.svelte";
import VipRewardsDistribution from "./parts/modern/vip-rewards-distribution.svelte";
import VipSportsbook from "./parts/modern/vip-sportsbook.svelte";
</script>

<Container maxWidth={false}>
	<div class="about-vip-modern">
		<VipHero />
		<VipReason />
		<VipCashback />
		<VipLevelUp />
		<VipRakeback />
		<VipClaimSteps />
		<VipRewardsDistribution />
		<VipRakeboost />
		<VipSportsbook />
		<VipCta />
	</div>
</Container>

<style>
	.about-vip-modern {

		margin-left: auto;

		margin-right: auto;

		display: flex;

		width: 100%;

		max-width: 1232px;

		flex-direction: column;

		gap: 4rem;

		padding-left: 1rem;

		padding-right: 1rem
}

	@media (min-width: 1024px) {
		.about-vip-modern {

				padding: 2rem
		}
	}
</style>
